import dayjs from 'dayjs';
import { REQUIRED_FIELD } from '../config/text/text';

export const RETURNS_LOCALSTORAGE_KEY = 'need-help-returns-form-';
export const DEFAULT_RETURNS_FORM_DATA = {
  exchange: false,
  information: '',
  reason: '',
};

export const RETURN_REASONS = [
  {
    label: 'I received the wrong item',
    value: 'wrong-item',
  },
  {
    label: 'The product did not match the description',
    value: 'mis-sold',
  },
  {
    label: 'The product was damaged/faulty',
    value: 'faulty',
  },
  {
    label: 'I no longer need this product',
    value: 'change-of-mind',
  },
  {
    label: 'Other (please specify)',
    value: 'other',
  },
];

export const GENERIC_REASON = {
  changeOfMind: 'changeOfMind',
  faulty: 'faulty',
};

export const convertReasonToGenericReason = (reason) => {
  switch (reason) {
    case 'wrong-item':
    case 'mis-sold':
    case 'faulty':
      return GENERIC_REASON.faulty;
    case 'change-of-mind':
    case 'other':
    default:
      return GENERIC_REASON.changeOfMind;
  }
};

export const generateReturnFormLocalStorageKey = (voucherCode) => {
  return RETURNS_LOCALSTORAGE_KEY + voucherCode;
};

export const storeFormData = (voucherCode, values) => {
  if (!localStorage || !voucherCode) {
    throw new Error('Cannot set localStorage');
  }

  const key = generateReturnFormLocalStorageKey(voucherCode);
  const data = JSON.stringify({
    ...values,
    submittedDate: dayjs().format('DD/MM/YYYY'),
  });

  localStorage.setItem(key, data);
};

export const getReturnsFormStoredData = (voucherCode) => {
  if (!window?.localStorage || !voucherCode) {
    return null;
  }

  const key = generateReturnFormLocalStorageKey(voucherCode);

  return JSON.parse(localStorage.getItem(key));
};

export const getReturnsFormInitialData = (voucherCode) => {
  if (!window?.localStorage || !voucherCode) {
    return DEFAULT_RETURNS_FORM_DATA;
  }

  return getReturnsFormStoredData(voucherCode) || DEFAULT_RETURNS_FORM_DATA;
};

export const hasFormBeenSubmitted = (voucherCode) => {
  if (!localStorage || !voucherCode) {
    return false;
  }

  const key = generateReturnFormLocalStorageKey(voucherCode);
  const data = JSON.parse(localStorage.getItem(key));

  return Boolean(data);
};

/** manually validate form as state is dependant on values */
export const validateReturnsForm = (values) => {
  const errors = {};

  if (!values.reason) {
    errors.reason = REQUIRED_FIELD;
  }
  if (values.reason === 'other' && !values.information) {
    errors.information = REQUIRED_FIELD;
  }

  return errors;
};

export const getShowOnlyContactStep = ({ voucher, genericReason }) => {
  return voucher.warehouseDeal && genericReason === GENERIC_REASON.faulty;
};

export const generatReturnsApiData = ({ values }) => {
  const reason = RETURN_REASONS.find((entry) => entry.value === values.reason);

  const data = {
    additionalInfo: values.information,
    exchangeAvailable: values.exchange || false,
    reason: reason?.label,
    returnsType: convertReasonToGenericReason(reason?.value),
  };

  if (values.submittedDate) {
    data.submittedDate = values.submittedDate;
  }

  return data;
};
